import React from 'react';
import { Form } from 'react-final-form';
import { useCreateEdge } from "services/Edges";
import { Card, CardBody, CardHeader, CardText, Button } from "reactstrap";
import TextField from 'components/form/TextField';
import validator from 'validator';

const validate = (values: any) => {
  const errors:any = {};

  if (!values.nodeOne || !validator.isMongoId(values.nodeOne)) {
    errors.nodeOne = 'Please enter a valid node ID';
  }

  if (!values.nodeTwo || !validator.isMongoId(values.nodeTwo)) {
    errors.nodeTwo = 'Please enter a valid node ID';
  }

  return errors;
};

function CreateEdgeForm() {
  const createEdge = useCreateEdge();

  const onSubmit = async (values: any) => {
    try {
      await createEdge(values.nodeOne, values.nodeTwo);
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    } catch (e) {
      window.alert(e.message);
    }
  };

  return (
    <Form
      // @ts-ignore
      validate={validate}
      onSubmit={onSubmit}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <Card>
            <CardHeader>Create Edge</CardHeader>
            <CardBody>
              <CardText>Enter the ID of two nodes to connect them.</CardText>
              <TextField name='nodeOne' placeholder='Node One' />
              <TextField name='nodeTwo' placeholder='Node Two' />
              <Button type='submit'>Submit</Button>
            </CardBody>
          </Card>
        </form>
      )}
    />
  );
}

export default CreateEdgeForm;
